import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "showButton", "keywrapper" ]

  show() {
    this.showButtonTarget.classList.add("d-none");
    this.keywrapperTarget.classList.remove("d-none");
  }
}
